import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { useLicSettings } from './use-lic-settings';

export type StaticAssetGroup = 'SharedImg';

export const getStaticAssetDomain = (
	staticAssetDomains: Record<string, string> | undefined,
	group: StaticAssetGroup,
	fallback: string | undefined,
): string => staticAssetDomains?.[group] || fallback || '';

/** Returns '' until LicSettings loads, so the old host is never requested first. */
export const useStaticAssetDomain = (group: StaticAssetGroup): string => {
	const { data, isFetched, isError } = useLicSettings();
	const { SiteConfigsData: siteConfigsData } = useGetSiteConfigs();

	if (!isFetched && !isError) {
		return '';
	}

	return getStaticAssetDomain(data?.staticAssetDomains, group, siteConfigsData?.ImageServerUrl);
};
